<footer class="footer">
	<section class="footer__principal">
		<div class="row">
			<div *ngFor="let item of listMenu" class="footer__principal__section col-lg-3 col-md-4 col-sm-4 col-xs-12">
				<h5 style="font-family: 'futura-pt-demi'">{{ item.name }}</h5>
				<ng-container *ngFor="let subitem of item.links">
					<a
						*ngIf="subitem.url.charAt(0) !== '/' && subitem.url.charAt(0) !== '#'"
						[href]="subitem.url"
						[target]="'_blank'"
						>{{ subitem.name }}</a
					>

					<a *ngIf="subitem.url.charAt(0) === '/' || subitem.url.charAt(0) === '#'" [routerLink]="subitem.url">{{
						subitem.name
					}}</a>
				</ng-container>
			</div>
			<div class="footer__principal__section col-lg-3 col-md-12 col-sm-12 col-xs-12">
				<a [routerLink]="['/']"
					><img
						src="assets/logo/JPHorizontalBlanco.svg"
						aria-label="logo"
						[routerLink]="'/'"
						alt="LOGO"
						class="img-logo"
				/></a>
				<p class="hash">
					Ven y disfruta la experiencia del Jockey Plaza con las personas que más quieres. <br />
					#JockeyTeQuiereFeliz
				</p>
				<div class="footer__principal__section__social" *ngIf="dataLinks">
					<a [href]="dataLinks.urlFacebook ? dataLinks.urlFacebook : '/'" [target]="'_blank'">
						<svg
							width="20"
							height="20"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							(click)="navigateUrl(dataLinks.urlFacebook)"
						>
							<path
								d="M27.3337 19.588C27.3337 24.4413 24.4403 27.3346 19.587 27.3346H18.0003C17.267 27.3346 16.667 26.7346 16.667 26.0013V18.308C16.667 17.948 16.9603 17.6413 17.3203 17.6413L19.667 17.6013C19.8537 17.588 20.0137 17.4547 20.0537 17.268L20.5203 14.7213C20.5603 14.4813 20.3737 14.2546 20.1203 14.2546L17.2803 14.2946C16.907 14.2946 16.6137 14.0013 16.6003 13.6413L16.547 10.3746C16.547 10.1613 16.7203 9.97465 16.947 9.97465L20.147 9.92131C20.3736 9.92131 20.547 9.74799 20.547 9.52132L20.4937 6.32129C20.4937 6.09462 20.3203 5.92131 20.0937 5.92131L16.4937 5.97465C14.2803 6.01465 12.5203 7.82797 12.5603 10.0413L12.627 13.708C12.6403 14.0813 12.347 14.3746 11.9737 14.388L10.3737 14.4146C10.147 14.4146 9.97367 14.5879 9.97367 14.8146L10.0137 17.348C10.0137 17.5746 10.187 17.748 10.4137 17.748L12.0137 17.7213C12.387 17.7213 12.6803 18.0146 12.6936 18.3746L12.8136 25.9747C12.827 26.7213 12.227 27.3346 11.4803 27.3346H8.41366C3.56032 27.3346 0.666992 24.4413 0.666992 19.5746V8.41463C0.666992 3.5613 3.56032 0.667969 8.41366 0.667969H19.587C24.4403 0.667969 27.3337 3.5613 27.3337 8.41463V19.588Z"
							/>
						</svg>
					</a>

					<a [href]="dataLinks.urlInstagram ? dataLinks.urlInstagram : '/'" [target]="'_blank'">
						<svg
							width="20"
							height="20"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							(click)="navigateUrl(dataLinks.urlInstagram)"
						>
							<path
								d="M19.587 0.667969H8.41366C3.56033 0.667969 0.666992 3.5613 0.666992 8.41464V19.5746C0.666992 24.4413 3.56033 27.3346 8.41366 27.3346H19.5737C24.427 27.3346 27.3203 24.4413 27.3203 19.588V8.41464C27.3337 3.5613 24.4403 0.667969 19.587 0.667969ZM14.0003 19.1746C11.147 19.1746 8.82699 16.8546 8.82699 14.0013C8.82699 11.148 11.147 8.82797 14.0003 8.82797C16.8537 8.82797 19.1737 11.148 19.1737 14.0013C19.1737 16.8546 16.8537 19.1746 14.0003 19.1746ZM21.8937 7.17464C21.827 7.33464 21.7337 7.4813 21.6137 7.61464C21.4803 7.73464 21.3337 7.82797 21.1737 7.89464C21.0137 7.9613 20.8403 8.0013 20.667 8.0013C20.307 8.0013 19.9737 7.86797 19.7203 7.61464C19.6003 7.4813 19.507 7.33464 19.4403 7.17464C19.3737 7.01464 19.3337 6.8413 19.3337 6.66797C19.3337 6.49464 19.3737 6.3213 19.4403 6.1613C19.507 5.98797 19.6003 5.85464 19.7203 5.7213C20.027 5.41464 20.4937 5.26797 20.9203 5.3613C21.0137 5.37464 21.0937 5.4013 21.1737 5.4413C21.2537 5.46797 21.3337 5.50797 21.4137 5.5613C21.4803 5.6013 21.547 5.66797 21.6137 5.7213C21.7337 5.85464 21.827 5.98797 21.8937 6.1613C21.9603 6.3213 22.0003 6.49464 22.0003 6.66797C22.0003 6.8413 21.9603 7.01464 21.8937 7.17464Z"
							/>
						</svg>
					</a>

					<a [href]="dataLinks.urlYoutube ? dataLinks.urlYoutube : '/'" [target]="'_blank'">
						<svg
							width="20"
							height="20"
							viewBox="0 0 28 22"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							(click)="navigateUrl(dataLinks.urlYoutube)"
						>
							<path
								d="M20.667 0.332031H7.33366C3.33366 0.332031 0.666992 2.9987 0.666992 6.9987V14.9987C0.666992 18.9987 3.33366 21.6654 7.33366 21.6654H20.667C24.667 21.6654 27.3337 18.9987 27.3337 14.9987V6.9987C27.3337 2.9987 24.667 0.332031 20.667 0.332031ZM16.5203 12.372L13.227 14.3454C11.8936 15.1454 10.8003 14.532 10.8003 12.972V9.01204C10.8003 7.45204 11.8936 6.83871 13.227 7.63871L16.5203 9.61202C17.787 10.3854 17.787 11.612 16.5203 12.372Z"
							/>
						</svg>
					</a>

					<a [href]="dataLinks.tikTok ? dataLinks.tikTok : '/'" [target]="'_blank'">
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							(click)="navigateUrl(dataLinks.tikTok)"
						>
							<path
								d="M18.1776 5.4701C18.1776 5.28047 18.1253 5.20854 17.9291 5.17585C15.6601 4.82275 14.1561 3.3711 13.6984 1.09554C13.6592 0.886296 13.5742 0.833984 13.378 0.833984C12.7437 0.840523 12.116 0.840523 11.4817 0.840523C11.0501 0.840523 11.0501 0.840523 11.0501 1.29171C11.0436 5.33278 11.024 9.37386 11.0305 13.4215C11.0305 14.6312 10.527 15.5336 9.46116 16.0828C8.36916 16.6452 7.28369 16.5732 6.29631 15.8147C5.38739 15.1216 4.99506 13.925 5.32854 12.8264C5.68165 11.656 6.49248 10.9628 7.70872 10.7732C7.93105 10.7405 8.15337 10.747 8.40185 10.734C8.40185 9.9689 8.40185 9.23 8.40185 8.4911C8.40185 8.02683 8.40185 8.02683 7.93105 8.03991C4.55695 8.11838 2.04599 11.1394 2.5691 14.4939C3.03991 17.5279 6.04129 19.6531 9.03613 19.0711C11.7694 18.5415 13.6134 16.3313 13.6199 13.5522C13.633 11.2178 13.6199 8.88997 13.6199 6.55557C13.6199 6.43787 13.6199 6.3267 13.6199 6.209C13.6461 6.20246 13.6788 6.19593 13.7049 6.18939C13.7703 6.27439 13.8357 6.3594 13.9011 6.44441C14.9277 7.68027 16.2486 8.28185 17.8506 8.26877C18.0795 8.26877 18.1776 8.20992 18.171 7.9549C18.1645 7.12446 18.171 6.30055 18.1776 5.4701Z"
							/>
						</svg>
					</a>

					<a [href]="dataLinks.whatsApp ? 'https://wa.me/' + dataLinks.whatsApp : '/'" target="_blank">
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							(click)="navigateUrl('https://wa.me/' + dataLinks.whatsApp)"
						>
							<path
								d="M18.3162 9.50805C18.0329 4.67472 13.6413 0.949724 8.58292 1.78306C5.09959 2.35806 2.30793 5.18304 1.76626 8.66637C1.44959 10.683 1.86628 12.5914 2.77461 14.1664L2.03293 16.9247C1.86627 17.5497 2.44125 18.1164 3.05792 17.9414L5.77459 17.1914C7.00792 17.9164 8.44959 18.333 9.99125 18.333C14.6913 18.333 18.5912 14.1914 18.3162 9.50805ZM14.0663 13.0997C13.9913 13.2497 13.8996 13.3914 13.7829 13.5247C13.5746 13.7497 13.3496 13.9164 13.0996 14.0164C12.8496 14.1247 12.5746 14.1747 12.2829 14.1747C11.8579 14.1747 11.3996 14.0747 10.9246 13.8664C10.4413 13.6581 9.96628 13.383 9.49128 13.0414C9.00794 12.6914 8.55793 12.2997 8.1246 11.8747C7.69126 11.4414 7.30791 10.983 6.95791 10.508C6.61624 10.033 6.34126 9.55804 6.14126 9.08304C5.94126 8.60804 5.84127 8.14972 5.84127 7.71639C5.84127 7.43305 5.89127 7.15805 5.99127 6.90805C6.09127 6.64972 6.24961 6.41639 6.47461 6.20806C6.74128 5.94139 7.03293 5.81639 7.34126 5.81639C7.45793 5.81639 7.57457 5.84138 7.68291 5.89138C7.79124 5.94138 7.89126 6.01638 7.96626 6.12472L8.93291 7.49137C9.00791 7.5997 9.06625 7.69138 9.09958 7.78304C9.14125 7.87471 9.15792 7.95804 9.15792 8.04137C9.15792 8.14137 9.1246 8.24139 9.06627 8.34139C9.00793 8.44139 8.93291 8.54137 8.83291 8.64137L8.51624 8.9747C8.46624 9.0247 8.44961 9.07471 8.44961 9.14138C8.44961 9.17471 8.45791 9.20804 8.46624 9.24138C8.48291 9.27471 8.49127 9.29971 8.49961 9.32471C8.57461 9.46638 8.70792 9.64137 8.89125 9.85803C9.08292 10.0747 9.28295 10.2997 9.49962 10.5164C9.72462 10.7414 9.94127 10.9414 10.1663 11.133C10.3829 11.3164 10.5662 11.4414 10.7079 11.5164C10.7329 11.5247 10.7579 11.5414 10.7829 11.5497C10.8163 11.5664 10.8496 11.5664 10.8913 11.5664C10.9663 11.5664 11.0163 11.5414 11.0663 11.4914L11.3829 11.1747C11.4912 11.0664 11.5913 10.9914 11.6829 10.9414C11.7829 10.883 11.8746 10.8497 11.9829 10.8497C12.0663 10.8497 12.1496 10.8664 12.2413 10.908C12.3329 10.9497 12.4329 10.9997 12.5329 11.0747L13.9163 12.058C14.0246 12.133 14.0996 12.2247 14.1496 12.3247C14.1912 12.4331 14.2163 12.533 14.2163 12.6497C14.1663 12.7914 14.1329 12.9497 14.0663 13.0997Z"
							/>
						</svg>
					</a>
				</div>
			</div>
			<div class="footer__principal__section col-sm-12 col-xs-12 section__play__store" *ngIf="dataLinks">
				Descarga nuestra app
				<div class="section__play__store__images">
					<img src="assets/logo/StoreBadge.svg" alt="badge" (click)="navigateUrl(dataLinks.android)" />
					<img src="assets/logo/AppBadge.svg" alt="badge" (click)="navigateUrl(dataLinks.ios)" />
				</div>
			</div>
		</div>
	</section>
	<section class="footer__copy">
		<div class="row">
			<div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 politicas">
				<div>
					<a href="/politicas-de-privacidad" [target]="'_blank'">Políticas de privacidad</a>
					<a *ngIf="linkSocialMediaPolicy" href="/politica-de-privacidad-de-redes-sociales" [target]="'_blank'"
						>Políticas de redes sociales</a
					>
					<a *ngIf="linkCookiePolicy" href="/politica-de-cookie" [target]="'_blank'">Políticas de cookies</a>
				</div>
			</div>
			<div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 copy p-0">
				©Copyright {{ myDate | date : 'yyyy' }} Administradora Jockey Plaza Shopping Center S.A.
			</div>
		</div>
	</section>
</footer>
